var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3539 14.3826L10.3539 11.912",
    stroke: "#CB2D2D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6478 14.3826L13.6478 11.912",
    stroke: "#CB2D2D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58826 7.79395H19.4118V7.79395C18.6444 7.79395 18.2607 7.79395 17.958 7.9193C17.5544 8.08647 17.2337 8.40716 17.0666 8.8108C16.9412 9.11346 16.9412 9.49715 16.9412 10.2645V15.2057C16.9412 16.7586 16.9412 17.5351 16.4588 18.0175C15.9763 18.4999 15.1999 18.4999 13.647 18.4999H10.3531C8.80016 18.4999 8.0237 18.4999 7.54127 18.0175C7.05885 17.5351 7.05885 16.7586 7.05885 15.2057V10.2645C7.05885 9.49715 7.05885 9.11346 6.93349 8.8108C6.76632 8.40716 6.44563 8.08647 6.04199 7.9193C5.73933 7.79395 5.35564 7.79395 4.58826 7.79395V7.79395Z",
    stroke: "#CB2D2D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4098 4.80519C10.5037 4.71764 10.7105 4.64027 10.9981 4.58509C11.2858 4.52991 11.6382 4.5 12.0008 4.5C12.3633 4.5 12.7158 4.52991 13.0034 4.58509C13.2911 4.64027 13.4979 4.71764 13.5917 4.80519",
    stroke: "#CB2D2D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.d8be3aa2c006c2d377903b540bdda19a.svg";
export { ForwardRef as ReactComponent };